import { render, staticRenderFns } from "./redpacketPull.vue?vue&type=template&id=f236ccb0&scoped=true&"
import script from "./redpacketPull.vue?vue&type=script&lang=js&"
export * from "./redpacketPull.vue?vue&type=script&lang=js&"
import style0 from "./redpacketPull.vue?vue&type=style&index=0&id=f236ccb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f236ccb0",
  null
  
)

export default component.exports